import React from 'react';
import { arrayOf, bool, func, number, node, object, oneOf, oneOfType, shape, string, } from 'prop-types';
import ReactSelect, { components } from 'react-select';
import { Flex } from '../layout';
import setClass from '../../common/set-class';
import Icon from '../icon';
const DropdownIndicator = (props) => {
    const { selectProps: { menuIsOpen }, } = props;
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(components.DropdownIndicator, { ...props },
        React.createElement(Icon, { name: "angle-down", size: "sm", className: setClass([
                'b-select__icon',
                menuIsOpen ? '' : 'b-select__icon--closed',
            ]) })));
};
const IconOption = (props) => {
    const { data: { label, icon }, } = props;
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(components.Option, { ...props },
        React.createElement(Flex, { align: "center" },
            React.createElement("img", { className: "b-select__option-icon", src: icon, alt: label }),
            React.createElement("span", { className: "b-select__option-icon-label" }, label))));
};
const IconValue = (props) => {
    const { data: { label, icon, hasValue }, } = props;
    const { selectProps: { isDisabled }, } = props;
    return (React.createElement(Flex, { align: "center", className: setClass([
            'b-select__value-icon',
            isDisabled ? 'b-select__value-icon--disabled' : '',
        ]) },
        React.createElement("img", { className: "b-select__option-icon", src: icon, alt: label }),
        React.createElement("span", { className: setClass([
                'b-select__option-icon-label',
                hasValue ? 'b-select__option-icon-label--has-value' : '',
            ]) }, label)));
};
const Select = (props) => {
    const { className, compact, errorText, disabled, label, kind, onChange, options, placeholder, testId, value, inputId, ...extra } = props;
    const customSelectComponents = kind === 'icon'
        ? {
            DropdownIndicator,
            Option: IconOption,
            SingleValue: IconValue,
        }
        : {
            DropdownIndicator,
        };
    const onSelectChange = (selectedValues, actionObj) => {
        onChange(selectedValues, actionObj);
    };
    const hasLabel = typeof label === 'string' && label !== '';
    const hasError = typeof errorText === 'string' && errorText !== '';
    return (React.createElement("div", { className: setClass([
            'b-select__wrapper',
            className,
            compact ? 'b-select--max-width' : '',
            kind === 'icon' ? 'b-select--icon-kind' : '',
        ]), "data-testid": testId },
        hasLabel ? (React.createElement("label", { htmlFor: inputId, className: "b-select__label b-txt" }, label)) : null,
        React.createElement(ReactSelect, { id: "b-select-id", inputId: inputId, className: hasError ? 'b-select--error' : 'b-select', classNamePrefix: "b-select", components: customSelectComponents, onChange: onSelectChange, options: options, placeholder: placeholder, blurInputOnSelect: true, menuPlacement: "auto", isSearchable: false, isDisabled: disabled, value: value, ...extra }),
        hasError ? (React.createElement("p", { className: "b-select__err-msg" },
            React.createElement(Icon, { name: "triangle-exclamation", className: "b-select__err-icon" }),
            errorText)) : null));
};
DropdownIndicator.propTypes = {
    selectProps: shape({ menuIsOpen: bool }),
};
DropdownIndicator.defaultProps = {
    selectProps: { menuIsOpen: bool },
};
IconOption.propTypes = {
    data: shape({ label: string, icon: node }),
};
IconOption.defaultProps = {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Validator... Remove this comment to see the full error message
    data: shape({ label: '', icon: React.createElement(React.Fragment, null) }),
};
IconValue.propTypes = {
    selectProps: shape({ isDisabled: bool }),
    data: shape({ label: string, icon: node }),
};
IconValue.defaultProps = {
    selectProps: { isDisabled: false },
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Validator... Remove this comment to see the full error message
    data: shape({ label: '', icon: React.createElement(React.Fragment, null) }),
};
Select.propTypes = {
    compact: bool,
    className: string,
    disabled: bool,
    errorText: string,
    extra: object,
    label: string,
    kind: oneOf(['default', 'icon']),
    onChange: func,
    options: arrayOf(shape({ label: string, value: oneOfType([string, number, bool]) })),
    placeholder: string,
    testId: string,
    inputId: string,
    value: shape({ label: string, value: oneOfType([string, number, bool]) }),
};
Select.defaultProps = {
    compact: false,
    className: null,
    disabled: false,
    errorText: '',
    extra: {},
    label: '',
    kind: 'default',
    onChange: () => { },
    options: [],
    placeholder: 'Select Option',
    testId: undefined,
    inputId: undefined,
    value: null,
};
export default Select;
export { DropdownIndicator, IconOption, IconValue };
